<script setup>
import { ref, defineExpose, inject, watch, onMounted } from "vue"
// import i18n from "@/i18n"
import basicFormCom from "./../common/basicForm.vue";
import compositionStructureCom from "./../common/compositionStructure.vue";
import imageUploadCom from "./../common/imageUpload.vue";
import customFieldCom from "./../common/customField.vue";
import { database_structure, getProductTemplateMenu } from "@/service"
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
import inputCom from "./../common/customFieldInput.vue";
// import { getFileUrl } from "@/service"
import { useRoute } from "vue-router";
// import { required } from "@vuelidate/validators";
// const props = defineProps({
//     hscodeList: {
//         type: Array,
//         default: () => []
//     }
// })
const menuList = ref([])
const isCheckForm = ref(false)
const route = useRoute()
const basicFormRef = ref(null)
const detailInfo = inject('detailInfo')
const showType = inject('showType')
const templateNameList = inject('templateNameList')
//基本信息
const formData = ref({
    title: getLangValue('product-template', "basicInfo"),
    fieldsList: [
        {
            label: getLangValue('product-template', "productName"),
            value: '',
            required: false,
        },
        {
            label: getLangValue('product-template', "type"),
            value: '',
            required: true,
        },
        {
            label: getLangValue('product-template', "inventory"),
            value: '',
            type: 'number',
            required: true,
        },
        {
            label: getLangValue('product-template', "price"),
            value: '',
            type: 'number1',
            required: true,
            unit: '',
        },
        {
            label: getLangValue('product-template', "size"),
            value: '',
            required: true,
        },
        {
            label: getLangValue('product-template', "color"),
            value: '',
            required: true,
        },
        {
            label: getLangValue('product-template', "description"),
            value: '',
            required: true,
        },
        {
            label: getLangValue('product-template', "batch"),
            value: '',
            required: true,
        },
        {
            label: getLangValue('product-template', "batchValue"),
            value: '',
            required: true,
        },
    ],
    addfieldsList: [],
})
//组成结构
const compositionStructureList = ref([
    // {
    //     value: '服装数据库',
    //     tableList: [
    //         {
    //             id: 'dwqdwq',
    //             value1: 'xx',
    //             value2: 'xx',
    //             value3: 'xx',
    //         },
    //         {
    //             id: 'dwqdwq',
    //             value1: 'xx',
    //             value2: 'xx',
    //             value3: 'xx',
    //         }
    //     ],
    //     inputVal: '',
    //     tableData: [
    //         {
    //             id: 'dwqdwqd11',
    //             value1: 'xx',
    //             value2: 'xx',
    //             value3: 'xx',
    //         },
    //         {
    //             id: 'dwqdwqd22',
    //             value1: 'xx',
    //             value2: 'xx',
    //             value3: 'xx',
    //         },
    //     ], //用于选择的数据库列表
    //     total: 0,
    // },
    // {
    //     value: '纱线数据库',
    //     tableList: [],
    //     tableData: [], //用于选择的数据库列表
    //     inputVal: '',
    //     total: 0,
    //     // showDelete:true,
    // }
])

//组成结构数据库list
// const { hscodeList } = toRefs(props)
//上传框list
const uploadList = ref([
    // {
    //     name:getLangValue('product-template', "productImg"),
    //     type: 'productImg',
    //     id: 'productsImgId',
    //     accept: '.png,.jpeg,.jpg,', // 接受的类型
    //     fileList: [],
    //     fileMaxSize: 1024 * 1024 * 50 //10M
    // },
    // {
    //     name: i18n.global.t("attribute.version_2d"),
    //     type: 'version_2d',
    //     id: 'productsversion_2dId',
    //     accept: '.png,.jpeg,.jpg,', // 接受的类型
    //     fileList: [],
    //     fileMaxSize: 1024 * 1024 * 50 //10M
    // },
    // {
    //     name: i18n.global.t("attribute.fitting_virtual"),
    //     type: 'fitting_virtual',
    //     id: 'productsfitting_virtualId',
    //     accept: '.png,.jpeg,.jpg,', // 接受的类型
    //     fileList: [],
    //     fileMaxSize: 1024 * 1024 * 50 //10M
    // }
])
// 输入框
const inputList = ref([])
// 自定义的字段list 包含有上传框的
const customFieldsList = ref([
    {
        name: '文本1', // 文本名称
        fieldsList: [
            {
                name: '字段1', //字段名称
                unit: '%', //字段单位
                value: '', // 字段值
            },
            {
                name: '字段2', //字段名称
                unit: 'cm', //字段单位
                value: '', // 字段值
            },
            {
                name: '字段3', //字段名称
                unit: 'g/m³', //字段单位
                value: '', // 字段值
            },
        ],
        showUpload: false,
        showDelete: true,
    },
    {
        name: '文本2', // 文本名称
        fieldsList: [
            {
                name: '字段1', //字段名称
                unit: '%', //字段单位
                value: '', //字段值
            },
            {
                name: '字段2', //字段名称
                unit: 'cm', //字段单位
                value: '', //字段值
            },
            {
                name: '字段3', //字段名称
                unit: 'g/m³', //字段单位
                value: '', //字段值
            },
        ],
        showUpload: true,
        id: 'customFiledUpload',
        accept: '', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 200, //200M
        showDelete: true,
    },
    {
        name: '文本3', // 文本名称
        fieldsList: [
            {
                name: '字段1', //字段名称
                unit: '%', //字段单位
                value: '', //字段值
            },
            {
                name: '字段2', //字段名称
                unit: 'cm', //字段单位
                value: '', //字段值
            },
            {
                name: '字段3', //字段名称
                unit: 'g/m³', //字段单位
                value: '', //字段值
            },
        ],
        showUpload: true,
        id: 'customFiledUpload3',
        accept: '', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 200, //200M
        showDelete: true,
    }
])

const getDataList = async (...args) => {
    // 获取组成结构的数据
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    const [index, currentPage] = args
    let params = {
        page: currentPage - 1,
        limit: 10,
        product_name: compositionStructureList.value[index].inputVal,
        supply_chain_id: compositionStructureList.value[index].inputVal1.join(','), // 供应链
        public_type: compositionStructureList.value[index].inputVal2, // 数据库公开类型
        // table_name: compositionStructureList.value[index].table_name,  // 根据index 去查询数据库
        // product_template_name: getHscodeName(compositionStructureList.value[index].value),
        user_id: user_id,
        role_key: compositionStructureList.value[index].value,
        product_template_name: '',
    }
    // console.log(params);
    const resp = await database_structure(params);
    if (resp.code == 0) {
        compositionStructureList.value[index].tableData = resp.payload.data
        compositionStructureList.value[index].total = resp.payload.total;
    }

}
const getDataList1 = async (page, product_template_name) => {
    // 获取组成结构数据
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    let params = {
        page: page,
        limit: 10,
        product_name: '', // 产品名称
        public_type: '', // 数据公开类型
        supply_chain_id: '', // 供应链supply_chain_id 可以多选
        user_id: user_id,
        role_key: product_template_name,
        product_template_name: '',
    }
    // console.log(params);
    const resp = await database_structure(params);
    return resp
}

const getTemplateMenu = async () => {
    // 获取模板菜单
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    if (data.length == 0) {
        const resp = await getProductTemplateMenu();
        if (resp) {
            menuList.value = resp.payload
        }
    } else {
        menuList.value = data;
    }

}
// 组成结构校验
const checkFormCompositionStructure = () => {
    let checkRes = true;
    for (let k in compositionStructureList.value) {
        if (compositionStructureList.value[k].required && compositionStructureList.value[k].tableList.length == 0) {
            document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
            checkRes = false;
            break;
        } else {
            document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
        }
    }
    return checkRes;
}
// 校验比例之和是否大于100
// 如果有类型的话是 根据类型之和不能超过100
// 没有类型的话就是全部之和不超过100
const checkFormCompositionStructure1 = () => {
    let checkRes = true;
    if (showType.value) {
        // 根据类型来
        for (let k in compositionStructureList.value) {
            if (compositionStructureList.value[k].tableList.length) {
                let [sum1, sum2, sum3] = [0, 0, 0];
                let [arr1, arr2, arr3] = [[], [], []];
                // 内衬
                arr1 = compositionStructureList.value[k].tableList.filter(item => item.value2 == 'lining')
                if (arr1.length) {
                    for (let i = 0; i < arr1.length; i++) {
                        console.log(arr1[i].value3);
                        sum1 += arr1[i].value3
                    }
                    if (sum1 > 100) {
                        document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
                        checkRes = false
                        break;
                    } else {
                        document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
                    }
                }
                // 外层
                arr2 = compositionStructureList.value[k].tableList.filter(item => item.value2 == 'shell')
                if (arr2.length) {
                    for (let i = 0; i < arr2.length; i++) {
                        sum2 += arr2[i].value3
                    }
                    if (sum2 > 100) {
                        document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
                        checkRes = false
                        break;
                    } else {
                        document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
                    }
                }
                // 夹层
                arr3 = compositionStructureList.value[k].tableList.filter(item => item.value2 == 'interior')
                if (arr3.length) {
                    for (let i = 0; i < arr3.length; i++) {
                        sum3 += arr3[i].value3
                    }
                    if (sum3 > 100) {
                        document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
                        checkRes = false
                        break;
                    } else {
                        document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
                    }
                }
            }
        }

    } else {
        for (let k in compositionStructureList.value) {
            if (compositionStructureList.value[k].tableList.length) {
                let sum = 0
                for (let i = 0; i < compositionStructureList.value[k].tableList.length; i++) {
                    sum += compositionStructureList.value[k].tableList[i].value3
                }
                if (sum > 100) {
                    document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
                    checkRes = false
                    break;
                } else {
                    document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
                }
            }
        }
    }

    return checkRes;
}

//校验数据如果只有一条的话 必须是内衬
const checkFormCompositionStructure2 = () => {
    let checkRes = true;
    if (showType.vaule) {
        for (let k in compositionStructureList.value) {
            if (compositionStructureList.value[k].tableList.length == 1 && compositionStructureList.value[k].tableList[0].value2 != 'lining') {
                // 1条数据 但是不是内衬的衣服
                document.querySelector(`#compositionStructure${k}`).classList.add('is-invalid')
                checkRes = false;
                break;
            } else {
                document.querySelector(`#compositionStructure${k}`).classList.remove('is-invalid')
            }
        }
    }
    return checkRes;
}

// 上传图片校验
const checkFormUpload = () => {
    let checkRes = true;
    isCheckForm.value = true
    for (let k in uploadList.value) {
        if (uploadList.value[k].required && uploadList.value[k].fileList.length == 0) {
            checkRes = false;
            document.querySelector(`#imageUpload${k}`).classList.add('is-invalid')
            break;
        } else {
            document.querySelector(`#imageUpload${k}`).classList.remove('is-invalid')
        }
        if (uploadList.value[k].fieldsList) {
            const { fieldsList } = uploadList.value[k]
            for (let kk in fieldsList) {
                let { required, value } = fieldsList[kk]
                if (required && !value) {
                    checkRes = false;
                    break;
                }
            }
        }

    }
    return checkRes;
}
// 自定义字段校验
const checkForm = () => {
    let checkRes = true;
    isCheckForm.value = true
    for (let k in customFieldsList.value) {
        const { fieldsList } = customFieldsList.value[k]
        for (let kk in fieldsList) {
            let { required, value } = fieldsList[kk]
            if (required && !value) {
                checkRes = false;
                break;
            }
        }
    }
    return checkRes;
}

// const getImageList = async (arr) => {
//     if (arr.length == 0) return []
//     let ids = arr.join(',')
//     const resp = getFileUrl({ attachments: ids })
//     return resp.payload
// }
const filterImglist = (valList, imageInfo) => {
    // 根据值筛选 图片
    if (valList && valList.length && Object.keys(valList).length) {
        const fileList = valList.map(item => {
            return imageInfo[item]
        })
        return fileList
    }
    return []
}
// const getHscodeName = (table_name) => {
//     return menuList.value.filter(item => item.table_name == table_name).length ? menuList.value.filter(item => item.table_name == table_name)[0].name : ""
// }
onMounted(() => {
    // getTemplateMenu()
})
watch(detailInfo, async (val) => {
    // 设置基本信息
    // 设置组成结构
    // 设置上传列表
    // 设置自定义字段
    if (menuList.value.length == 0)
        await getTemplateMenu();
    const { product_info, structures } = val
    // console.log('pi', product_info);
    // ------便利产品信息
    //基本信息
    const basicInfo = product_info.children[0];
    formData.value.title = basicInfo.name;
    formData.value.title_en = basicInfo.name_en;
    formData.value.fieldsList = basicInfo.children.filter(item => (!item.extra || (item.extra && !item.extra.type)) && item.show).map(item => {
        // {
        //     label:getLangValue('product-template', "inventory"),
        //     value: '',
        //     type: 'number',
        //     required: true,
        // },
        // {
        //     label:getLangValue('product-template', "price"),
        //     value: '',
        //     type: 'number1',
        //     required: true,
        //     unit: '元',
        // },
        item.type1 = JSON.stringify(item.type)
        if (item.key == 'product_info_base_info_inventory' || item.key == 'product_info_base_info_batch_size' || item.key =='product_info_base_info_inventory_unit') { //新增了一个成本 也是数字类型
            item.type = 'number'
            // item.value = item.value == 0 ? '' : item.value
        }
        if (item.key == 'product_info_base_info_price') {
            item.type = 'number1'
            item.unit = item.unit ? item.unit : ''
            // item.value = item.value == 0 ? '' : item.value
        }
        // item.value = item.value
        // 后台存储的是字符串 把product_info_base_info_inventory_unit 值转为数字
        if (item.key == 'product_info_base_info_inventory_unit') {
            item.value = item.value? item.value.replace(/[^0-9]/ig, '') : ''
        }
        item.label = item.name
        item.label_en = item.name_en
        return item
    });
    formData.value.addfieldsList = basicInfo.children.filter(item => item.extra && item.extra.type == 99).map(item => {
        // item.value = item.value
        item.label = item.name
        item.label_en = item.name_en
        return item
    });
    // 组成结构
    // const cSList = product_info.children.filter(item => item.extra && item.extra.myKey == '组成结构')
    const cSList = product_info.children.filter(item => item.key == 'product_info_base_info_structure')
    const getList = (data) => {
        if (structures && structures.length && structures != null) {
            for (const item in data) {
                // 通过id匹配
                const structure = structures.find(structure => structure.id === data[item].id);
                if (structure) {
                    data[item].pid = structure.pid;
                    data[item].name = structure.name;
                }
                data[item].value2 = data[item].layer;
                data[item].value3 = data[item].proportion;
            }
        }
        return data
    }
    if (cSList.length) {
        // 判断是show的
        compositionStructureList.value = cSList[0].children.filter(item => item.show).map(item => {
            let arr = []
            if (item.value != '无') {
                arr = templateNameList.value.filter(template => template.role_key === item.value)
            } else {
                arr = [{ name: getLangValueByKey("base.none"), name_en: getLangValueByKey("base.none", 'en') }]
            }

            return {
                name: item.name,
                name_en: item.name_en,
                p_name: arr.length ? arr[0].name : '',
                p_name_en: arr.length ? arr[0].name_en : '',
                value: item.value,
                required: item.required,
                // showDelete: true,
                tableList: item.extra.data ? getList(item.extra.data) : [],
                tableData: [],
                inputVal: '',
                inputVal1: [],
                inputVal2: '',
                total: 0,
                extra:{template_type: item.extra.template_type || 0},
                table_name: menuList.value.filter(item1 => item1.id === item.value).length ? menuList.value.filter(item1 => item1.id === item.value)[0].table_name : ''
            }
        })
        // console.log(compositionStructureList.value);
        // 需要获取数据
        compositionStructureList.value.forEach(item => {
            getDataList1(0, item.value).then(res => {
                if (res.code === 0) {
                    item.tableData = res.payload.data
                    item.total = res.payload.total;
                }
            })
        })
    } else {
        compositionStructureList.value = [];
    }
    //上传框list
    // const upList = product_info.children.filter(item => (item.key == '产品图片' || item.key == "2D版型" || item.key == "虚拟合身度") && item.show)
    const upList = product_info.children.filter(item => (item.key.indexOf('product_info_product_picture') > -1 || item.key.indexOf('product_info_product_style') > -1 || item.key.indexOf('product_info_product_pattern') > -1 || item.key.indexOf('product_info_virtual_fit') > -1 ||  item.key.indexOf('product_trademark') > -1) && item.show)
    if (upList.length) {
        uploadList.value = []
        // 先显示产品图片的
        let arr1 = upList.filter(item => item.key.indexOf('product_info_product_picture') > -1).map(item => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra.type,
                key: item.key,
                showDelete: true,
                fileList: route.query.id ? filterImglist(item.value, val.imageInfo) : [],
                accept: item.extra.accept,
                fileMaxSize: item.extra.fileMaxSize,
                info: '',
                required: item.required,
                isShow: item.show,
                id: item.extra.id,
            }
        })
        uploadList.value = [...uploadList.value, ...arr1]
        let arr2 = upList.filter(item => item.key.indexOf('product_info_product_style') > -1).map(item => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra.type,
                key: item.key,
                showDelete: true,
                fileList: filterImglist(item.value, val.imageInfo),
                accept: item.extra.accept,
                fileMaxSize: item.extra.fileMaxSize,
                info: getLangValue('product-template', "upload_info"),
                required: item.required,
                isShow: item.show,
                id: item.extra.id,
            }
        })
        uploadList.value = [...uploadList.value, ...arr2]

        let arr3 = upList.filter(item => item.key.indexOf('product_info_product_pattern') > -1).map(item => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra.type,
                key: item.key,
                showDelete: true,
                fileList: filterImglist(item.value, val.imageInfo),
                accept: item.extra.accept,
                fileMaxSize: item.extra.fileMaxSize,
                info: getLangValue('product-template', "upload_info"),
                required: item.required,
                isShow: item.show,
                id: item.extra.id,
            }
        })
        // console.log(arr3);
        uploadList.value = [...uploadList.value, ...arr3]
        let arr4 = upList.filter(item => item.key.indexOf('product_info_virtual_fit') > -1).map(item => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra.type,
                key: item.key,
                showDelete: true,
                fileList: route.query.id ? filterImglist(item.value, val.imageInfo) : [],
                accept: item.extra.accept,
                fileMaxSize: item.extra.fileMaxSize,
                info: '',
                required: item.required,
                isShow: item.show,
                id: item.extra.id,
                fieldsList: item.children ? item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: '', //字段单位
                        key: ele.key,
                        value: ele.value,
                        required: ele.required,
                        // isShow: ele.show,
                    }
                }) : []
            }
        })
        uploadList.value = [...uploadList.value, ...arr4]

        let arr5 = upList.filter(item => item.key.indexOf('product_trademark') > -1).map((item, index) => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra?.type || 'product_trademark',
                key: item.key,
                showDelete: true,
                fileList: filterImglist(item.value, val.imageInfo),
                accept: item.extra?.accept || '.png,.jpeg,.jpg,',
                fileMaxSize: item.extra?.fileMaxSize || 1024 * 1024 * 50,
                info: getLangValue('product-template', "upload_info"),
                required: item.required,
                isShow: item.show,
                id: item.extra?.id || 'product_trademark' + index,
            }
        })
        // console.log(arr3);
        uploadList.value = [...uploadList.value, ...arr5]
        // uploadList.value = upList.map((item) => {
        //     if (route.query.id) {
        //         return {
        //             name: item.name,
        //             type: item.extra.type,
        //             showDelete: false,
        //             fileList: filterImglist(item.value, val.imageInfo),
        //             id: item.extra.id,
        //             // accept: '.png,.jpeg,.jpg,', // 接受的类型
        //             // fileMaxSize: 1024 * 1024 * 50,
        //             accept: item.accept,
        //             fileMaxSize: item.fileMaxSize,
        //             value: item.value,
        //             //10M
        //         }
        //     } else {
        //         return {
        //             name: item.name,
        //             type: item.extra.type,
        //             showDelete: false,
        //             fileList: [],
        //             id: item.extra.id,
        //             // accept: '.png,.jpeg,.jpg,', // 接受的类型
        //             // fileMaxSize: 1024 * 1024 * 50 //10M
        //             accept: item.accept,
        //             fileMaxSize: item.fileMaxSize,
        //         }
        //     }

        // })
        // console.log(uploadList.value);
    } else {
        uploadList.value = [];
    }
     // 自定义是输入框数据
     const inputList1 = product_info.children.filter(item => (item.key.indexOf('product_washing_instructions')> -1 || item.key.indexOf('product_recycling_discarding_instructions')> -1) && item.show);
    if (inputList1.length) {
        inputList.value = inputList1.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                showDelete: true,
                key: item.key,
                value: item.value
            }
            return m
        })
    } else {
        inputList.value = [];
    }
    //自定义的字段list
    const csFieldList = product_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (csFieldList.length) {
        customFieldsList.value = csFieldList.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                fieldsList: [],
                showUpload: false,
                showDelete: true,
                value: item.value,
                key: item.key
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: ele.value,
                        required: ele.required,
                    }
                })
            if (item.extra.myKey == "文本项+附件项") {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.id = item.extra.id
                m.accept = item.extra.accept
                m.fileList = filterImglist(item.value, val.imageInfo)
                m.fileMaxSize = item.extra.fileMaxSize
            }
            return m
        })
    } else {
        customFieldsList.value = [];
    }
})

defineExpose({
    formData,
    compositionStructureList,
    uploadList,
    customFieldsList,
    basicFormRef,
    checkForm,
    checkFormUpload,
    checkFormCompositionStructure,
    checkFormCompositionStructure1,
    checkFormCompositionStructure2,
    inputList
})
</script>
<template>
    <div class="productInfo">
        <!-- 基本信息 -->
        <basicFormCom :formData="formData" ref="basicFormRef" />
        <!-- 组成结构 -->
        <compositionStructureCom @getDataList="getDataList" :menuList="menuList"
            :compositionStructureList="compositionStructureList" :currentPageList="currentPageList"
            :pageOptionList="pageOptionList" />
        <!-- :hscodeList="hscodeList" -->
        <!-- 图片上传部分 -->
        <imageUploadCom :isCheckForm="isCheckForm" :uploadList="uploadList" />
        <!-- 输入信息框 -->
        <inputCom v-model:customFieldsList="inputList" />
        <!-- 自定义字段部分 -->
        <customFieldCom :isCheckForm="isCheckForm" :customFieldsList="customFieldsList" />
    </div>
</template>
<style scoped></style>